import type { AgentVoiceTranscriptionResponse } from "openapi/api/model"

import {
  robinVoiceTranscriptionErrorCode,
  type RobinVoiceTranscriptionErrorCode,
} from "./voice-transcription-errors"

const ROBIN_VOICE_TRANSCRIPTION_TIMEOUT_MS = 120_000

export const robinVoiceTranscriptionRequestOptions = {
  timeout: ROBIN_VOICE_TRANSCRIPTION_TIMEOUT_MS,
  timeoutErrorMessage: `Voice transcription timed out after ${ROBIN_VOICE_TRANSCRIPTION_TIMEOUT_MS / 1000} seconds.`,
} as const

export type RobinVoiceTranscriptionResult =
  | { ok: true; text: string }
  | { ok: false; error: RobinVoiceTranscriptionErrorCode }

/**
 * Normalizes the generated transcription request into the recorder contract.
 * The API layer owns transport failures and backend response shape, while the
 * dictation hook only needs to know whether usable composer text was produced.
 */
export async function robinVoiceTranscriptionResultFromRequest(
  request: Promise<AgentVoiceTranscriptionResponse>,
): Promise<RobinVoiceTranscriptionResult> {
  try {
    const payload = await request
    const transcript = payload.text.trim()
    if (!transcript) return { ok: false, error: "no-speech" }
    return { ok: true, text: transcript }
  } catch (error) {
    return { ok: false, error: robinVoiceTranscriptionErrorCode(error) }
  }
}
